<template>
  <v-form @submit.prevent="save" lazy-validation v-model="valid" ref="form">
    <v-card elevation="2" tile>

      <v-card-title v-if="this.isUpdate">
        <p>Editar Projeto</p> 
      </v-card-title>
      <v-toolbar v-else color="primary" class="title" tile elevation="0" dark>Novo Projeto</v-toolbar>

      <v-divider />

      <v-card-text class="mb-n5">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="projetoForm.titulo"
              label="*Qual o título do Projeto?"
              filled
              :rules="requiredRule"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-n7">
          <v-col cols="12">
            <v-textarea
              v-model="projetoForm.descricao"
              filled
              label="*Qual a descrição do Projeto?"
              rows="1"
              auto-grow
              :rules="requiredRule"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row class="mt-n7">
        </v-row>

        <v-row v-if="isUpdate">
          <v-col cols="4" lg="4">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataInicioFormatada"
                  label="*Qual o início do Projeto?"
                  filled
                  :rules="requiredRule"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="projetoForm.inicio = coverterData(dataInicioFormatada)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="projetoForm.inicio"
                no-title
                locale="pt-br"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4" lg="4">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataTerminoFormatada"
                  label="*Qual o término do Projeto?"
                  filled
                  :rules="requiredRule"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="projetoForm.termino = coverterData(dataTerminoFormatada)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="projetoForm.termino"
                no-title
                locale="pt-br"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4" lg="4">
            <v-menu
              ref="menu3"
              v-model="menu3"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataExtensaoFormatada"
                  label="*Qual a extensão do projeto?"
                  filled
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="projetoForm.extensao = coverterData(dataExtensaoFormatada)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="projetoForm.extensao"
                no-title
                locale="pt-br"
                @input="menu3 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="6">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataInicioFormatada"
                  label="*Qual o início do Projeto?"
                  filled
                  :rules="requiredRule"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="projetoForm.inicio = coverterData(dataInicioFormatada)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="projetoForm.inicio"
                no-title
                locale="pt-br"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataTerminoFormatada"
                  label="*Qual o término do Projeto?"
                  filled
                  :rules="requiredRule"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  @blur="projetoForm.termino = coverterData(dataTerminoFormatada)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="projetoForm.termino"
                no-title
                locale="pt-br"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <p><span class="caption">* Campos Obrigatórios</span></p>
      </v-card-text>

      <v-card-actions class="py-3 mx-1">
        <v-btn :loading="isFetching" color="primary" type="submit"> {{ isUpdate ? "Salvar alterações" : "Salvar" }} </v-btn>
        <v-btn color="secondary" @click.prevent="cancel" >Cancelar</v-btn>
        <br>
        
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: {
    logicaIntervencaoId: {
      required: false,
    },
    projeto: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      projetoForm: this.projeto ? { ...this.projeto } : this.projetoFormReset(),
      valid: true,
      requiredRule: [(v) => !!v || "Campo obrigatório"],
      errorMessage: "",
      dataInicioFormatada: '',
      menu1: false,
      dataTerminoFormatada: '',
      menu2: false,
      dataExtensaoFormatada: '',
      menu3: false,
    };
  },
  computed: {
    isUpdate() {
      return !!this.projeto;
    },
    ...mapState('projeto', {
      isFetching: state => state.isFetching,
    }),    
  },

  watch: {
    'projetoForm.inicio' () {
      this.dataInicioFormatada = this.formatarData(this.projetoForm.inicio)
    },
    'projetoForm.termino' () {
      this.dataTerminoFormatada = this.formatarData(this.projetoForm.termino)
    },
    'projetoForm.extensao' () {
      this.dataExtensaoFormatada = this.formatarData(this.projetoForm.extensao)
    },
  },

  methods: {
    save() {
      if(this.$refs.form.validate()) {
        this.persist().then((projeto) => {
          console.log("thennnnnnnnnnn")
          this.projetoForm = this.projetoFormReset();
          this.$emit("save", { projeto });
          console.log("!this.isUpdate ", !this.isUpdate)
          if(!this.isUpdate) {
          console.log(" this.$router ")
            this.$router.push({ name: 'Projeto', params: { projetoId: projeto.id }})
          }
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    persist() {
      return this.isUpdate ? this.update() : this.create();
    },
    create() {
      console.log("projeto/criarProjeto")
      return this.$store.dispatch("projeto/criarProjeto", this.projetoForm);
    },
    update() {
      return this.$store.dispatch("projeto/editarProjeto", this.projetoForm);
    },
    cancel() {
      this.$refs.form.reset();
      this.$emit("cancel");
    },
    projetoFormReset() {
      return {inicio: null, termino: null, extensao:null};
    },
    formatarData (data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    },
    coverterData (data) {
      if (!data) return null

      const [dia, mes, ano] = data.split('/')
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
  },
  created: function () {
    this.dataInicioFormatada = this.formatarData(this.projetoForm.inicio)
    this.dataTerminoFormatada = this.formatarData(this.projetoForm.termino)
    this.dataExtensaoFormatada = this.formatarData(this.projetoForm.extensao)
  }  
};
</script>

<style scoped>
</style>
